import { useEffect, useState } from "react";
import { api, fmtErr } from "../../lib/api";
import { toast } from "sonner";
import { EnvelopeSimple, PaperPlaneTilt } from "@phosphor-icons/react";

export default function EmailCard({ isAdmin, onStatus }) {
  const [status, setStatus] = useState(null);
  const [log, setLog] = useState([]);
  const [filter, setFilter] = useState("");
  const [testing, setTesting] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/org/email-status");
      setStatus(data);
      onStatus?.(data.configured);
      const l = await api.get("/org/email-log", { params: filter ? { status: filter } : {} });
      setLog(l.data.log);
    } catch (e) { toast.error(fmtErr(e)); }
  };
  useEffect(() => { load(); }, [filter]);

  const sendTest = async () => {
    setTesting(true);
    try {
      const r = await api.post("/org/email-test");
      if (r.data.status === "sent") toast.success(`Test email sent to your inbox (id ${r.data.id})`);
      else toast.warning(`Email ${r.data.status}: ${r.data.reason || r.data.error || ""}`);
      load();
    } catch (e) { toast.error(fmtErr(e)); } finally { setTesting(false); }
  };

  if (!isAdmin) return null;
  return (
    <div className="space-y-3" data-testid="email-card">
      <div className="flex items-center gap-3 flex-wrap">
        <EnvelopeSimple size={16} className="text-[var(--c-muted)]" />
        <span className={`flex items-center gap-1.5 text-xs font-medium ${status?.configured ? "text-[var(--c-green)]" : "text-[var(--c-red)]"}`}
          data-testid="email-status">
          <span className={`w-2 h-2 rounded-full ${status?.configured ? "bg-[var(--c-green)]" : "bg-[var(--c-red)]"}`} />
          {status?.configured ? "Connected" : "Not configured"}
        </span>
        <span className="text-[10px] font-mono text-[var(--c-muted)]">{status?.provider} · from: {status?.from_name}</span>
        <span className="text-[10px] font-mono text-[var(--c-muted)]" data-testid="email-sent-count">{status?.emails_sent ?? 0} sent</span>
        <button onClick={sendTest} disabled={testing} data-testid="email-test-btn"
          className="ml-auto h-7 px-3 flex items-center gap-1.5 rounded-sm bg-[var(--c-accent)] text-white text-[11px] font-medium hover:bg-[var(--c-accent)]/85 disabled:opacity-40">
          <PaperPlaneTilt size={12} /> {testing ? "Sending…" : "Send Test Email"}
        </button>
      </div>
      <div>
        <div className="flex items-center gap-2 mb-1.5">
          <span className="text-[10px] font-mono uppercase tracking-widest text-[var(--c-muted)]">Delivery log (last 100)</span>
          <select value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="email-log-filter"
            className="h-6 bg-[var(--c-bg)] border border-[var(--c-border)] rounded-sm text-[10px] text-[var(--c-text)] px-1.5">
            <option value="">all</option><option value="sent">sent</option>
            <option value="failed">failed</option><option value="skipped">skipped</option>
          </select>
        </div>
        <div className="max-h-44 overflow-y-auto border border-[var(--c-border)]/60 rounded-sm">
          {log.length === 0 && <div className="text-[11px] text-[var(--c-muted)] p-3">No emails logged yet</div>}
          {log.map((e) => (
            <div key={e.id} className="flex items-center gap-2 px-3 py-1.5 border-b border-[var(--c-border)]/40 last:border-0 text-[11px]"
              data-testid={`email-log-${e.id}`}>
              <span className={`w-14 shrink-0 font-mono uppercase text-[9px] ${
                e.status === "sent" ? "text-[var(--c-green)]" : e.status === "failed" ? "text-[var(--c-red)]" : "text-[var(--c-amber)]"}`}>{e.status}</span>
              <span className="text-[var(--c-muted)] truncate">{e.to}</span>
              <span className="text-[var(--c-text)] truncate flex-1">{e.subject}</span>
              <span className="text-[9px] font-mono text-[var(--c-muted)] shrink-0">{(e.created_at || "").slice(0, 16).replace("T", " ")}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
